import * as Service from 'types/service';
import { ServiceDefinedState } from 'state/service/config';
import { StoreType } from '@tock/shared/utils/connect';
import { createSelector } from 'reselect';

// ARE YOU LOOKING FOR `serviceConfig` SELECTORS?! You're in the wrong place
// This file is for `service.config` selectors.

// TODO: Move contents to serviceSelector.ts or refactor service.config and serviceConfig
// to remove redundant data

export const serviceConfigSelector = createSelector(
  (state: StoreType) => state.service.config,
  (config) => config
);

export const serivceConfigBusinessSeatedStatusSelector = createSelector(
  (state: StoreType): ServiceDefinedState[] => state.service.config.businessDefinedStates,
  (businessDefinedStates: ServiceDefinedState[]): ServiceDefinedState => {
    const seatedStatus = businessDefinedStates.find((businessState) => {
      if (businessState.primaryState === 'SEATED' && businessState.stateName === undefined) {
        return true;
      }
      return false;
    });

    //Default to lime when can't find default seated status.
    return seatedStatus
      ? seatedStatus
      : ({ primaryState: 'SEATED', color: 'lime', ordering: 0 } as ServiceDefinedState);
  }
);

export const serviceNeedsSelector = createSelector(
  serviceConfigSelector,
  (config): Service.Need[] => config.serviceNeeds
);

// serviceConfig state also has fields `textingEnabled` and `textingAvailable`
// Freindly reminder to make sure to double check
export const serviceTextingEnabledSelector = createSelector(
  serviceConfigSelector,
  (config): boolean => config.textingEnabled && config.textingAvailable
);
